import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Icon from '../../../../components/Icons';

import { useGlobal } from '../../../../contexts/Global/context';

import Accordion from '../../../../components/Accordion';
import CardDefault from '../../../../components/Cards/Default';
import Button from '../../../../components/Button';
import Alert from '../../../../components/Alert';
import Modal from '../../../../components/Modal';
import Loading from '../../../../components/Loading';

import { LinkCardCustom } from '../../../../components/Cards/LinkCard';

import { getLotacoes, deleleLotacoes } from '../../../../services';

import { PageContainer } from '../../../../styles/styles';

import * as S from './styles';
import { checkIsSupport } from '../../../../utils';

function SelecionarLotacoes({ location: { cameFromForm, message } }) {
    const { dataActiveContract, contrastTheme, setShowSupportModal } = useGlobal();

    const [showModal, setShowModal] = useState(false);
    const [dataDeletingLotacao, setDataDeletingLotacao] = useState({});
    const [occupationDeleted, setOccupationDeleted] = useState(false);
    const [alertMessage, setAlertMessage] = useState(message || {});
    const [alreadySearched, setAlreadySearched] = useState(false);
    const [lotacoes, setLotacoes] = useState([]);

    const history = useHistory();

    const LINK_FORM = './formulario_lotacao';

    function handleEditLotacao(dataLotacao) {
        history.push({
            pathname: LINK_FORM,
            dataLotacao,
        });
    }

    async function handleDeleteLotacao(dataLotacao) {
        if (checkIsSupport()) {
            setShowSupportModal(true);
            return;
        }

        const responseDelete = await deleleLotacoes(dataLotacao.codigoLotacaoTS);

        if (!responseDelete.errorDescription) {
            const index = lotacoes.findIndex((lotacao) => lotacao.codigoLotacao === dataLotacao.codigoLotacao);

            lotacoes.splice(index, 1);

            setOccupationDeleted(true);

            setAlertMessage({ type: 3, title: 'Você excluiu uma lotação.' });

            setShowModal(false);

            return;
        }

        setOccupationDeleted(true);
        setAlertMessage({
            type: 1,
            title: `Ocorreu um erro ao tentar deletar. Motivo: ${responseDelete.errorDescription}`,
        });
        setShowModal(false);
    }

    function createActionsIcons(lotacao) {
        return (
            <>
                <S.ContainerIcon
                    style={{ marginRight: 25 }}
                    onClick={() => {
                        // Funcoes dos icones comentadas por funcionalidades nao concluidas
                        handleEditLotacao(lotacao);
                    }}
                >
                    <Icon name="edit" tooltip="Alterar" title="Alterar" color={contrastTheme ? '#FFF333' : '#EC6E0C'} />
                </S.ContainerIcon>
                <S.ContainerIcon
                    onClick={() => {
                        setShowModal(true);
                        setDataDeletingLotacao(lotacao);
                    }}
                >
                    <Icon
                        name="delete"
                        tooltip="Excluir"
                        title="Excluir"
                        color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                    />
                </S.ContainerIcon>
            </>
        );
    }

    useEffect(() => {
        (async () => {
            const responseLotacoes = await getLotacoes(dataActiveContract.numero);

            if (responseLotacoes) setLotacoes(responseLotacoes);

            setAlreadySearched(true);
        })();
    }, []);

    return (
        <PageContainer>
            {alreadySearched ? (
                <>
                    {lotacoes.length === 0 ? (
                        <Grid container>
                            <Grid item xs={10} md={6}>
                                <LinkCardCustom
                                    link={{
                                        pathname: LINK_FORM,
                                    }}
                                    title="Nova lotação"
                                    desc="Adicione e gerencie uma lotação para sua empresa."
                                    icons={{ left: { name: 'corporate_fare' } }}
                                />
                            </Grid>
                        </Grid>
                    ) : (
                        <>
                            {(cameFromForm || occupationDeleted) && (
                                <Alert type={alertMessage.type} title={alertMessage.title} />
                            )}

                            <Accordion title="Lotações cadastradas" hasCollapse={false}>
                                {lotacoes?.map((lotacao) => {
                                    const ActionsIcons = createActionsIcons(lotacao);
                                    const title = `${lotacao.codigoLotacao} - ${lotacao.nomeLotacao}`;

                                    return <CardDefault title={title} actionsIcons={ActionsIcons} />;
                                })}
                            </Accordion>

                            <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                                <Button
                                    id="continueStep"
                                    type="primary"
                                    onClick={() =>
                                        history.push({
                                            pathname: LINK_FORM,
                                        })
                                    }
                                >
                                    Nova lotação
                                </Button>
                            </Grid>
                        </>
                    )}
                </>
            ) : (
                <S.LoadingContainer>
                    <Loading />
                </S.LoadingContainer>
            )}

            <Modal
                title="Você quer excluir a lotação?"
                subtitle="A lotação será definitivamente excluída da plataforma."
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <Grid container direction="row" justifyContent="flex-end" alignItems="center">
                    <Button
                        type="secondary"
                        style={{ marginTop: '20px', marginRight: '25px' }}
                        onClick={() => {
                            setShowModal(false);
                            setDataDeletingLotacao({});
                        }}
                    >
                        Não quero
                    </Button>

                    <Button
                        type="primary"
                        style={{ marginTop: '20px' }}
                        onClick={() => handleDeleteLotacao(dataDeletingLotacao)}
                    >
                        Sim, quero
                    </Button>
                </Grid>
            </Modal>
        </PageContainer>
    );
}

export default SelecionarLotacoes;
